import { styled } from 'baseui'

export const AvatarWrapper = styled('span', {
  position: 'relative',
  display: 'inline-flex',
  flexShrink: 0,
  width: '2.1rem',
  height: '2.1rem',
})

export const AvatarFrame = styled('span', ({ $theme }) => ({
  display: 'block',
  width: '100%',
  height: '100%',
  borderRadius: '999px',
  overflow: 'hidden',
  backgroundColor: $theme.colors.white,
  boxShadow: `0 0 0 2px ${$theme.colors.primary}`,
}))

export const AvatarImage = styled('img', {
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transform: 'scale(1.15)',
})

export const OnlineDot = styled('span', ({ $theme }) => ({
  position: 'absolute',
  right: '-0.125rem',
  bottom: '-0.125rem',
  width: '0.675rem',
  height: '0.675rem',
  borderRadius: '999px',
  backgroundColor: $theme.colors.positive,
  boxShadow: `0 0 0 2px ${$theme.colors.white}`,
}))
